import 'core-js/stable';
import { render } from 'react-dom';
import { App } from './App';

render(App, document.getElementById('conversations-app'));
